import { validatorsRepository } from "@frui.ts/validation/dist";
import { observable, runInAction } from "mobx";
import { sleep } from "../utils/sleep";
import type LocaleProvider from "./localeProvider";
import type LocalizationService from "./localizationService";
import type NewVersionService from "./newVersionService";
import type SecurityService from "./securityService";
import type ValidationService from "./validationService";
import type EnumService from "./enumService";

export default class InitializationService {
  @observable isPreLoginInitialized = false;
  @observable isPostLoginInitialized = false;

  constructor(
    private localeProvider: LocaleProvider,
    private localizationService: LocalizationService,
    private securityService: SecurityService,
    private validationService: ValidationService,
    private newVersionService: NewVersionService,
    private enumService: EnumService
  ) {}

  async preLoginInitialize() {
    this.localeProvider.initialize(["cs"]);
    await Promise.all([
      this.localizationService.initialize(),
      this.securityService.initialize(),
      this.newVersionService.initialize(),
    ]);

    runInAction(() => {
      this.isPreLoginInitialized = true;
    });
  }

  async postLoginInitialize() {
    await sleep(200);
    await Promise.all([this.enumService.initialize(), this.validationService.initialize(validatorsRepository as any)]);
    runInAction(() => (this.isPostLoginInitialized = true));
  }

  async initialize() {
    if (!this.isPreLoginInitialized) {
      await this.preLoginInitialize();
    }

    this.postLoginInitialize();
  }
}
